import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=1c47a617&scoped=true"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"
import style0 from "./_layout.css?vue&type=style&index=0&id=1c47a617&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c47a617",
  null
  
)

export default component.exports